module.exports = __webpack_public_path__ + "static/media/product_video_placeholder.407926ec.png";